<template>
  <div class="md-layout">
    <validation-form @on-submit="exportPDF" class="w-full">
      <md-card>
        <md-card-content>
          <div class="mt-3">
            <p class="font-[600] text-lg">
              {{ this.$t("extended_exportation.mailing_label_for") }}
            </p>
          </div>

          <div class="md-layout-item md-size-100 md-layout gap-10">
            <md-radio v-model="mailingLabelFor" value="families"
              ><span class="radio-text">{{
                this.$t("extended_exportation.parents")
              }}</span></md-radio
            >
            <md-radio v-model="mailingLabelFor" value="students"
              ><span class="radio-text">{{
                this.$t("class.students")
              }}</span></md-radio
            >
            <md-radio v-model="mailingLabelFor" value="teachers"
              ><span class="radio-text">{{
                this.$t("class.teachers")
              }}</span></md-radio
            >
            <md-radio v-model="mailingLabelFor" value="counselors"
              ><span class="radio-text">{{
                this.$t("counselor.counselors")
              }}</span></md-radio
            >
          </div>

          <div class="md-layout-item md-size-100 mt-3">
            <div class="md-layout-item md-size-33 p-0">
              <date-picker-custom
                :label="$t('extended_exportation.enter_date')"
                v-model="datePicker"
                :disabledDate="disabledDate"
              ></date-picker-custom>
            </div>
          </div>
          <div
            class="w-full"
            v-if="
              this.mailingLabelFor === 'families' ||
                this.mailingLabelFor === 'students'
            "
          >
            <div class="mt-3">
              <p class="font-[600] text-lg">
                {{
                  this.mailingLabelFor === "families"
                    ? this.$t("extended_exportation.parent_of_student")
                    : this.$t("extended_exportation.student_belong_to")
                }}
              </p>
            </div>

            <div class="md-layout-item md-size-100 md-layout">
              <div class="md-layout-item md-size-33 pl-0">
                <checkboxMultiSelect
                  class="w-full"
                  v-model="programSelect.values"
                  :label="programSelect.label"
                  :options="programSelect.options"
                  trackBy="id"
                  displayField="name"
                  :showSelectAll="true"
                ></checkboxMultiSelect>
              </div>
              <div class="md-layout-item md-size-33">
                <checkboxMultiSelect
                  v-model="gradeSelect.values"
                  :label="gradeSelect.label"
                  :options="gradeSelect.options"
                  trackBy="id"
                  displayField="name"
                  :showSelectAll="true"
                ></checkboxMultiSelect>
              </div>
              <!--              <div class="md-layout-item md-size-33">
                              <checkboxMultiSelect
                                v-model="studentSelectValue"
                                label="common.student"
                                :options="studentList"
                                trackBy="id"
                                displayField="name"
                                @filtering="getStudent($event.text)"
                                @select="selectItem"
                                @removed="removedItem"
                                @open="getStudent()"
                              ></checkboxMultiSelect>
                            </div>-->
            </div>
          </div>

          <div class="mt-3">
            <p class="font-[600] text-lg">
              {{ this.$t("extended_exportation.sort_by") }}
            </p>
          </div>
          <div class="md-layout-item md-size-100 md-layout gap-10">
            <md-radio v-model="sortBy" value="full_name_user_to"
              ><span class="radio-text">{{ sortByText.name }} </span></md-radio
            >
            <md-radio v-model="sortBy" value="address"
              ><span class="radio-text"
                >{{ sortByText.address }}
              </span></md-radio
            >
          </div>
        </md-card-content>
      </md-card>
      <div class="flex justify-center w-full">
        <md-button type="submit" class="md-warning md-round"
          >{{ $t("communication.send_email") }}
        </md-button>
      </div>
    </validation-form>
  </div>
</template>
<script>
import { service_paths } from "@/constants/Services";
import checkboxMultiSelect from "@/components/Base/CheckboxMultiSelect";
import { Message } from "@/helpers/utils";

export default {
  components: { checkboxMultiSelect },
  data() {
    return {
      gradeSelect: {
        label: this.$t("common.grade"),
        options: [],
        values: []
      },
      programSelect: {
        label: this.$t("student.program"),
        options: [],
        values: []
      },
      // studentList: [],
      // studentSelectValue: [],
      // studentSelected: [],
      datePicker: "",
      mailingLabelFor: "families",
      sortBy: "full_name_user_to",
      sortByText: {
        name: this.$t("extended_exportation.parents_name"),
        address: this.$t("extended_exportation.parents_address")
      }
    };
  },
  created() {
    this.getGrades();
    this.getProgram();
  },
  methods: {
    disabledDate(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },

    async getGrades() {
      let grades = await this.$axios
        .get(service_paths.grades, { limit: 30 })
        .then(response => response.data.data);
      this.gradeSelect.options = grades.map(grade => ({
        id: grade.name,
        name: grade.name
      }));
    },

    async getProgram() {
      let programs = await this.$axios
        .get(service_paths.programs, { limit: 20 })
        .then(response => response.data.data);
      this.programSelect.options = programs.map(program => ({
        id: program.id,
        name: program.name
      }));
    },

    /*    async getStudent(event) {
     let params = {
     search_key: event,
     fields: ["full_name", "student_code"],
     grades: this.gradeSelect.values,
     program_ids: this.programSelect.values,
     limit: 20
     };
     let students = await this.$axios
     .get(
     `${service_paths.students}/grades-and-programs`,
     params,
     undefined,
     undefined,
     undefined,
     undefined,
     false
     )
     .then(response => response.data.data);
     let optionList = students.filter(type => {
     return !this.studentSelected
     .map(item => getId(item))
     .includes(getId(type));
     });
     optionList = optionList.map(student => ({
     id: getId(student),
     name: `${student.full_name} - ${student.student_code}`
     }));
     this.studentList = [...this.studentSelected, ...optionList];
     },
     selectItem(event) {
     this.studentSelected.push(event.itemData);
     },
     removedItem(event) {
     this.studentSelected = this.studentSelected.filter(item => {
     return item.name !== event.itemData?.name;
     });
     },*/
    exportPDF() {
      let gradeIds = this.gradeSelect.values;
      let programIds = this.programSelect.values;
      if (gradeIds.length === this.gradeSelect.options.length) {
        gradeIds = [];
      }
      if (programIds.length === this.programSelect.options.length) {
        programIds = [];
      }
      let param = {
        effective_date: this.datePicker,
        sort_by: this.sortBy,
        grades: gradeIds,
        programs: programIds
        // student_ids: this.studentSelectValue
      };
      this.$axios
        .get(
          `${service_paths.export}/mailing-labels/pdf/${this.mailingLabelFor}`,
          param
        )
        .then(res => {
          if (res.status === 200) {
            Message.success(
              this.$t("extended_exportation.export_file_successfully")
            );
          }
        });
    }
  },
  watch: {
    mailingLabelFor: function(value) {
      this.gradeSelect.values = [];
      this.programSelect.values = [];
      if (value === "families") {
        this.sortByText.name = this.$t("extended_exportation.parents_name");
        this.sortByText.address = this.$t(
          "extended_exportation.parents_address"
        );
      }
      if (value === "students") {
        this.sortByText.name = this.$t("extended_exportation.students_name");
        this.sortByText.address = this.$t(
          "extended_exportation.students_address"
        );
      }
      if (value === "teachers") {
        this.sortByText.name = this.$t("extended_exportation.teachers_name");
        this.sortByText.address = this.$t(
          "extended_exportation.teachers_address"
        );
      }
      if (value === "counselors") {
        this.sortByText.name = this.$t("extended_exportation.counselors_name");
        this.sortByText.address = this.$t(
          "extended_exportation.counselors_address"
        );
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.md-layout {
  .radio-text {
    @apply text-[#242424];
  }

  .md-error {
    color: red;
    font-size: 12px;
  }
}
</style>
